import React from 'react';
import { Breadcrumb } from '@/components/ui/navigation';
import { Card } from '@/components/ui/cards';
import { PageSpinner } from '@/components/ui/loading';
import type { IconScoutName } from '@/components/ui/images/IconScout';


interface RouteItem {
  text: string;
  onClick?: () => void;
}

interface PageLayoutProps {
  // Modo manual (legacy, opcional)
  routes?: RouteItem[];
  icon?: IconScoutName;
  backTo?: string;
  onBackClick?: () => void;
  
  // Props compartidas
  children: React.ReactNode;
  titleVariant?: 'header-4' | 'header-5' | 'header-6' | 'body-medium';
  supportingText?: string;
  
  // Modo automático con override dinámico
  dynamicTitle?: string;

  // Loading state
  isLoading?: boolean;

  // Páginas de aterrizaje (ej. dashboard como home) que no necesitan breadcrumb
  // ni quedar dentro de la tarjeta blanca con sombra — ambas por defecto en false
  // para no alterar ninguna de las páginas existentes. Al ocultar el breadcrumb
  // también se quita el margen superior del contenido (ya no hay nada arriba que
  // separar), para que no quede un espacio sin fondo blanco antes del contenido.
  hideBreadcrumb?: boolean;
  hideCard?: boolean;
}

export const PageLayout: React.FC<PageLayoutProps> = ({
  routes,
  icon,
  children,
  titleVariant,
  supportingText,
  backTo,
  onBackClick,
  dynamicTitle,
  isLoading = false,
  hideBreadcrumb = false,
  hideCard = false,
}) => {
  // Si se pasan routes, calcular título desde ahí (modo manual)
  const manualTitle = routes && routes.length > 0 ? routes[routes.length - 1].text : undefined;
  const content = isLoading ? <PageSpinner /> : children;

  return (
    <div>
      {!hideBreadcrumb && (
        <div className="mt-4 md:mt-6 px-4 md:px-8 lg:px-16">
          <Breadcrumb
            icon={icon}
            items={routes}
            title={manualTitle}
            titleVariant={titleVariant}
            supportingText={supportingText}
            backTo={backTo}
            onBackClick={onBackClick}
            dynamicTitle={dynamicTitle}
          />
        </div>
      )}

      <div className={`${hideBreadcrumb ? 'mb-4 md:mb-6' : 'my-4 md:my-6'} px-4 md:px-8 lg:px-16`}>
        {hideCard ? content : (
          <Card elevation={2} padding = "" className="p-4 md:p-6 lg:p-8">
            {content}
          </Card>
        )}
      </div>
    </div>
  );
};

export default PageLayout;
